import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { MemberStatusState } from './member-status.state';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([MemberStatusState])]
})
export class MemberStatusStoreModule {}
